export const uuidRegExpString = '[A-F0-9]{8}-[A-F0-9]{4}-4[A-F0-9]{3}-[89AB][A-F0-9]{3}-[A-F0-9]{12}';

export const uuidRegExp = new RegExp(`^${uuidRegExpString}$`, 'i');
